import React from 'react';
import cx from 'classnames';

const TitleBlockView = ({ properties, metadata }) => {
  const data = metadata || properties || {};

  const title = data.title || '';
  const size = data.size || 'h1';
  const align = data.align || 'left';
  const blockWidth = data.blockWidth || 'normal';

  const TitleTag = size;

  return (
    <div
      className={cx(
        `has--blockWidth--${blockWidth}`,
        `align-${align}`,

        'fcmh-title-block',
      )}
    >
      <TitleTag className="documentFirstHeading">{title}</TitleTag>
    </div>
  );
};

export default TitleBlockView;
